import { render, staticRenderFns } from "./SettlementTable.vue?vue&type=template&id=36928da4&scoped=true"
import script from "./SettlementTable.vue?vue&type=script&lang=js"
export * from "./SettlementTable.vue?vue&type=script&lang=js"
import style0 from "./SettlementTable.vue?vue&type=style&index=0&id=36928da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36928da4",
  null
  
)

export default component.exports